import { useState } from "react";
import { Queued } from "./Queued";
import { Failed } from "./Failed";
import { Deferred } from "./Deferred";
import { Delivered } from "./Delivered";
import { Tabs } from "../../../components/Tabs";
import { AllEmailLogs } from "./AllEmailLogs";
import { Open } from "./Open";

const tabs = [
  {
    label: "All",
  },
  {
    label: "Queued",
  },
  {
    label: "Failed",
  },
  {
    label: "Deferred",
  },
  {
    label: "Delivered",
  },
   {
    label: "Open",
  },
]

export const EmailLogs = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full`}>
      <div className={`w-full border rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51 bg-white`}>
        
        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          {
            activeIndex === 0 && (
              <AllEmailLogs />
            )
          }
          {
            activeIndex === 1 && (
              <Queued />
            )
          }
          {
            activeIndex === 2 && (
              <Failed />
            )
          }
          {
            activeIndex === 3 && (
              <Deferred />
            )
          }
          {
            activeIndex === 4 && (
              <Delivered />
            )
          }
           {
            activeIndex === 5 && (
              <Open />
            )
          }
        </div>
      </div>
    </div>
  )
}

